
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { COST_CENTRE_METADATA } from './cost-centre.metadata';
import { CostCentre } from './cost-centre.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class CostCentreEntityDecoratorBase extends GenericEntityDecorator<CostCentre, string> {
  constructor() {
    super(COST_CENTRE_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): string {
    if (params == null || params.ccId == null) {
      return null;
    }
    return params.ccId;
  }
  toKeyUrlPathSegments(key: string): string {
    if (key == null) {
      return null;
    }
    return key;
  }
  toKeyRouteSegments(item: CostCentre): any[] {
    const key: string = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




